import React, { useEffect, useState } from 'react';
import LabelDirectorySelect from '../labels/LabelDirectorySelect';
import OpenImageDrawerButton from '../labels/OpenImageDrawerButton';
import { Box } from '@mui/material';

const MAX_SELECTION = 9;

const ImagePromptSelectorManager = () => {
    const root = document.getElementById('labeled-files-root');
    const labels = root ? JSON.parse(root.dataset.labels || '[]') : [];

    const isDisabled = root?.dataset.disabled === 'true';
    const initialPath = root?.dataset.labelSelected || '';
    const initialFiles = root ? JSON.parse(root.dataset.selectedFiles || '[]') : [];
    const imagesViewUrl = root?.dataset.imagesViewUrl;

    const [selectedPath, setSelectedPath] = useState(initialPath);
    const [selectedFiles, setSelectedFiles] = useState(initialFiles);

    const handleFilesUpdate=(files)=>{
        setSelectedFiles(files);
    }

    return (
        <Box display="flex" flexDirection="column" gap={2}>
            <Box display="flex" alignItems="center" gap={2}>
                <LabelDirectorySelect
                    labels={labels}
                    value={selectedPath}
                    onChange={setSelectedPath}
                    disabled={isDisabled}
                />
                <OpenImageDrawerButton
                    selectedPath={selectedPath}
                    selectedFiles={selectedFiles}
                    disabled={isDisabled}
                    imagesViewUrl={imagesViewUrl}
                    maxSelection={MAX_SELECTION}
                    onSelectedChange={handleFilesUpdate}
                />
            </Box>
            <input type="hidden" name="image_prompt_directory" value={selectedPath} />
            {/* Hidden inputs for Laravel form submission */}
            {selectedFiles.map((file) => (
                <input
                    key={file}
                    type="hidden"
                    name="image_prompt_files[]"
                    value={file}
                />
            ))}
        </Box>
    );
};

export default ImagePromptSelectorManager;
